// src/components/common/TitleWithBack.js
import React from 'react';
import BackButton from './BackButton';

const TitleWithBack = ({ title, level = 'h3', className = '' }) => {
  const Heading = level;
  
  const containerStyle = {
    background: 'linear-gradient(145deg,rgb(247, 243, 243),rgb(255, 255, 255))', // subtle gradient
    padding: '0.75rem 1.5rem',
    borderRadius: '8px',
    boxShadow: '0 3px 5px rgba(0, 0, 0, 0.1)',
    marginBottom: '1rem',
    display: 'flex',
    alignItems: 'center'
  };

  const headingStyle = {
    fontSize: '1.5rem',
    fontFamily: 'var(--font-sans)',
    letterSpacing: '0.5px',
    color: '#333',
    margin: 0
  };

  return (
    <div style={containerStyle}>
      <BackButton />
      <Heading className={`ms-3 ${className}`} style={headingStyle}>
        {title}
      </Heading>
    </div>
  );
};

export default TitleWithBack;
